import React from "react";
import "../styles/MemberDetails.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SideBar from "../components/SideBar";
import "../styles/WalletPage.css";
import cash from "../assets/images/tc-cash-wallet 1.png";
import units from "../assets/images/tc-units-wallet 2.png";

function AgentWalletPage() {
  const location = useLocation();
  const agent = location.state?.agent;
  const navigate = useNavigate();

  const goToWallet = () => {
    navigate("/agent-wallet-details", { state: { agent } });
  };

  const goToInviteHistory = () => {
    navigate("/agent-invite-history", { state: { agent } });
  };

  const goToPromotion = () => {
    navigate("/agent-promotion-history", { state: { agent } });
  };

  const goToagentDetails = () => {
    navigate("/agent-details", { state: { agent } });
  };

  console.log("Received customer:", agent);

  return (
    <div className="member-details-layout">
      <SideBar />

      <div className="member-details-main">
        {/* Header */}
        <div className="details-header">
          <h2 style={{width:"330px"}}>Retail Business Agent Details</h2>
          <p>You can edit your details to update your profile</p>
        </div>

        {/* Breadcrumb */}
        <div className="breadcrumb">
          <Link to="/manage-agent" className="breadcrumb-link">
            Home
          </Link>
          <span className="breadcrumb-separator">{">"}</span>
          <Link to="/manage-agent" className="breadcrumb-link">
            Manage Retail Advertising Business Agent
          </Link>
          <span className="breadcrumb-separator">{">"}</span>
          <span className="breadcrumb-current">Agent Details</span>
        </div>

        {/* buttons */}
        <div className="top-bar">
          {/* tap buttons */}
          <div className="top-buttons">
            <button className="tab-btn" onClick={goToagentDetails}>
              Personal Details
            </button>
            <button className="tab-btn active" onClick={goToWallet}>
              Wallet Details
            </button>
            <button className="tab-btn" onClick={goToInviteHistory}>
              Invitation Details
            </button>
            <button className="tab-btn" onClick={goToPromotion}>
              Promote / Demote
            </button>
          </div>
        </div>

        {/* Wallet Section */}
        <div className="wallet-section">
          <div className="wallet-card">
            <h3>TopCoin UK Units Wallet</h3>
            <img src={units} alt="Units Wallet" className="wallet-img" />
            <p className="balance-label">Available Balance</p>
            <h2 className="balance-value">{agent?.value || "0 units"}</h2>
            <Link
              to="/agent-units-transaction-history"
              state={{ agent }}
              className="wallet-link"
            >
              Transaction History &gt;&gt;
            </Link>
          </div>

          <div className="wallet-card">
            <h3>TopCoin UK Cash Wallet</h3>
            <img src={cash} alt="Cash Wallet" className="wallet-img" />
            <h2 className="balance-value">N/A</h2>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentWalletPage;
